import { render, staticRenderFns } from "./RelatorioAlertas.vue?vue&type=template&id=a0ad9850&scoped=true"
import script from "./RelatorioAlertas.vue?vue&type=script&lang=js"
export * from "./RelatorioAlertas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ad9850",
  null
  
)

export default component.exports